import { render, staticRenderFns } from "./filmdetail.vue?vue&type=template&id=3fd73612&scoped=true&"
import script from "./filmdetail?vue&type=script&lang=js&"
export * from "./filmdetail?vue&type=script&lang=js&"
import style0 from "./filmdetail.scss?vue&type=style&index=0&id=3fd73612&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd73612",
  null
  
)

export default component.exports